<!-- 积分审核  to Examine-->
<template>
  <div class="toExamine">
    <div class="form_header">
      <el-form ref="form" :model="userform" label-width="90px">
        <div class="form_list">
          <el-form-item label="用户名：">
            <el-input v-model="userform.username"></el-input>
          </el-form-item>
          <el-form-item label="用户邮箱：">
            <el-input v-model="userform.email"></el-input>
          </el-form-item>
          <el-form-item label="订单号：">
            <el-input v-model="userform.order_id"></el-input>
          </el-form-item>
          <el-form-item label="产品线：">
            <!-- <el-input v-model="userform.p_id"></el-input> -->
            <el-select v-model="userform.p_id" placeholder="请选择产品线" @change="getModedd">
              <el-option v-for="item in ProductsList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="userform.p_id!==''" label="产品型号：">
            <!-- <el-input v-model="userform.model"></el-input> -->
            <el-select v-model="userform.model" placeholder="请选择产品型号" no-data-text="该产品线没有产品型号">
              <el-option v-for="item in getModelList" :key="item.id" :label="item.name" :value="item.model"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="序列号：">
            <el-input v-model="userform.serial_number"></el-input>
          </el-form-item>
          <el-form-item label="来源：">
            <el-select v-model="userform.platform" placeholder="请选择来源">
              <el-option label="pc" :value=1></el-option>
              <el-option label="无线" :value=2></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="userform.status" placeholder="请选择审核状态">
              <el-option label="待审核" value="0"></el-option>
              <el-option label="审核通过" value="1"></el-option>
              <el-option label="审核拒绝" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-button class="btn_box" type="primary" @click="onSubmit">搜索</el-button>
          <el-button @click="quxiao">取消</el-button>
          <el-button type="primary" icon="el-icon-upload2" @click="exportlist">导出</el-button>
          <el-button type="primary" @click="batch(1)">批量通过</el-button>
          <el-button type="primary" @click="batch(2)">批量拒绝</el-button>
        </div>
      </el-form>
    </div>
    <div class="user_list">
      <el-table :data="userList" style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <el-table-column type="selection" width="50" fixed></el-table-column>
        <el-table-column type="index" label="序号" width="50" fixed></el-table-column>
        <el-table-column prop="user.username" label="用户名" fixed width="120">
          <!-- <template slot-scope="scope">
            <span>{{scope.row.user.username || ''}}</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="order_id" label="订单编号" width="250"></el-table-column>
        <el-table-column prop="products.name" label="产品线" width="200">
          <!-- <template slot-scope="scope">
            <span>{{scope.row.products.name}}</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="integral.model" label="产品型号" width="150">
          <!-- <template slot-scope="scope">
            <span>{{scope.row.integral.model}}</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="serial_number" label="产品序列号" width="180">
          <!-- <template slot-scope="scope">
            <span>{{scope.row.serial_number}}</span>
          </template> -->
        </el-table-column>

        <!-- <el-table-column prop="aimg" label="安装图片">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 40px" :src="domainUrl+scope.row.aimg" :preview-src-list="scope.row.aimglist"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="ximg" label="序列号图片" width="100">
          <template slot-scope="scope">
            <el-image style="width: 40px; height: 40px" :src="domainUrl+scope.row.ximg" :preview-src-list="scope.row.ximglist"></el-image>
          </template>
        </el-table-column>-->
        <el-table-column prop="user.email" label="邮箱" width="170">
          <!-- <template slot-scope="scope">
            <span>{{scope.row.user.email}}</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="integral.integral" label="申请积分">
          <!-- <template slot-scope="scope">
            <span>{{scope.row.integral.integral}}</span>
          </template> -->
        </el-table-column>
        <!-- <el-table-column prop="country" label="地址" width="300">
          <template slot-scope="scope">
            <span>{{scope.row.country.pinyin}}</span>
            <span v-if="scope.row.province!==null">{{scope.row.province.pinyin}}</span>
            <span v-if="scope.row.city!==null">{{scope.row.city.pinyin}}</span>
            <span v-if="scope.row.address!==null">{{scope.row.address.pinyin}}</span>
          </template>
        </el-table-column>-->
        <el-table-column prop="platform" label="来源" >
          <template slot-scope="scope">
            <span v-if="scope.row.platform==1">pc</span>
            <span v-if="scope.row.platform==2">无线</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="时间">
          <template slot-scope="scope">
            <span>{{filterTime(scope.row.created_at)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" fixed="right">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">待审核</span>
            <span v-if="scope.row.status==1">已通过</span>
            <span v-if="scope.row.status==2">已拒绝</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.status==1">已通过</span>
            <span v-else-if="scope.row.status==2">已拒绝</span>
            <span v-else>
              <el-button @click="handleClick(scope.row)" type="text" size="small">通过</el-button>
              <el-button type="text" size="small" @click="editbox(scope.row)">拒绝</el-button>
            </span>
            <el-button style="margin-left:10px" type="text" size="small" @click="detailsbox(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
    <!-- 拒绝弹窗 -->
    <el-dialog :title="titleName" :visible.sync="pop_up" @close="cancelform">
      <el-form :model="Edform" :rules="rules" label-width="80px">
        <el-form-item label="原因" prop="reason">
          <el-input v-model="Edform.reason"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelform">取 消</el-button>
        <el-button type="primary" @click="SubmitAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量拒绝弹窗 -->
    <el-dialog :title="titleName" :visible.sync="pop_upTwo" @close="cancelformTwo">
      <el-form :model="EdformTWO" :rules="rules" label-width="80px">
        <el-form-item label="原因" prop="reason">
          <el-input v-model="EdformTWO.reason"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelformTwo">取 消</el-button>
        <el-button type="primary" @click="SubmitAddTwo">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 详情？ -->
    <el-dialog title="详情" :visible.sync="deilt" width="1000px" @close="cancelform">
      <div class="deilt" v-if="detailsData">
        <div class="boxTwo">
          <div class="name">用户名</div>
          <div class="title">{{ detailsData.user && detailsData.user.username}}</div>
        </div>
        <div class="boxTwo">
          <div class="name">邮箱</div>
          <div class="title">{{ detailsData.user && detailsData.user.email}}</div>
        </div>
        <div class="boxTwo">
          <div class="name">订单编号</div>
          <div class="title">{{detailsData.order_id}}</div>
        </div>
        <div class="boxTwo">
          <div class="name">产品线</div>
          <div class="title">{{detailsData.products.name}}</div>
        </div>
        <div class="boxTwo">
          <div class="name">产品型号</div>
          <div class="title">{{detailsData.integral.model}}</div>
        </div>
        <div class="boxTwo">
          <div class="name">产品序列号</div>
          <div class="title">{{detailsData.serial_number}}</div>
        </div>
        <div class="boxTwo">
          <div class="name">积分</div>
          <div class="title">{{detailsData.integral.integral}}</div>
        </div>
        <div class="boxTwo">
          <div class="name">安装地址</div>
          <div class="title">
            <span>{{detailsData.country.pinyin}}</span>
            <span v-if="detailsData.province!==''&& detailsData.province!==null">{{detailsData.province.pinyin}}</span>
            <span v-if="detailsData.city!=='' && detailsData.city!==null">{{detailsData.city.pinyin}}</span>
            <span v-if="detailsData.address!==''&& detailsData.address!==null">{{detailsData.address.pinyin}}</span>
          </div>
        </div>
        <div class="boxTwo">
          <div class="name">按照图片</div>
          <div class="title">
            <el-image v-for="item in detailsData.aimglist" :key="item.index" :src="item" style="width: 100px; height: 100px" :preview-src-list="detailsData.aimglist"></el-image>
          </div>
        </div>
        <div class="boxTwo">
          <div class="name">序列号图片</div>
          <div class="title">
            <el-image v-for="item in detailsData.ximglist" :key="item.index" :src="item" style="width: 100px; height: 100px" :preview-src-list="detailsData.ximglist"></el-image>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deilt = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { hostimg, excelexport } from "../../api/comm.js";
import {
  auditlists,
  auditsh,
  batchoperation,
  getProducts,
  getModel
} from "../../api/integral.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      userform: {
        order_id: "",
        serial_number: "",
        model: "",
        status: "",
        p_id: "",
        platform: ""
      },
      Edform: {
        reason: ""
      },
      EdformTWO: {
        reason: ""
      },
      userList: [],
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      titleName: "新增",
      pop_up: false,
      rules: {
        reason: [{ required: true, message: "请输入拒绝原因", trigger: "blur" }]
      },
      domainUrl: "",
      juid: "",
      Checklist: [],
      detailsData: {
        user: {
          username: "",
          email: ""
        },
        products: {
          name: "",
          model: ""
        },
        integral: {
          name: "",
          integral: "",
          model: "",
          serial_number: ""
        },
        country: {
          pinyin: ""
        },
        province: {
          pinyin: ""
        },
        city: {
          pinyin: ""
        },
        address: {
          pinyin: ""
        }
      },
      deilt: false,
      pop_upTwo: false,
      ProductsList: [],
      getModelList: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rowStyle() {
      return { textAlign: "center" };
    },
    //产品线
    Productsdd() {
      getProducts().then(res => {
        // console.log("产品线", res);
        if (res.status_code == 200) {
          this.ProductsList = res.data;
        }
      });
    },
    //获取产品型号
    getModedd(e) {
      // console.log(e);
      let data = {
        p_id: e
      };
      getModel(data).then(res => {
        // console.log("产品型号", res);
        if (res.status_code == 200) {
          this.getModelList = res.data;
          this.userform.model=''
        }
      });
    },
    //实时域名
    domainName() {
      hostimg().then(res => {
        // console.log(res);
        if (res.code == 200) {
          this.domainUrl = res.data.url;
          this.Productsdd();
          this.auditLis();
        }
      });
    },
    //  时间换算
    filterTime(time) {
      var date = new Date(Number(time + "000"));
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    //积分审核列表  auditlists
    auditLis() {
      let data = {
        page: this.currentindex,
        page_size: this.pageSize,
        email: this.userform.email || "",
        username: this.userform.username || "",
        order_id: this.userform.order_id || "",
        model: this.userform.model || "",
        p_id: this.userform.p_id || "",
        serial_number: this.userform.serial_number || "",
        status: this.userform.status || "",
        platform: this.userform.platform || "",
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      auditlists(data).then(res => {
        if (res.status_code == 200) {
          // res.data.data.forEach((ele, i) => {
          //   // res.data.data[i].aimg = ele.aimg.split(",");
          //   // res.data.data[i].ximg = ele.ximg.split(",");
          //   res.data.data[i].aimglist = [];
          //   res.data.data[i].ximglist = [];
          //   ele.aimg.split(",").forEach(eles => {
          //     res.data.data[i].aimglist.push(this.domainUrl + eles);
          //   });
          //   ele.ximg.split(",").forEach(eled => {
          //     res.data.data[i].ximglist.push(this.domainUrl + eled);
          //   });
          //   // res.data.data[i].aimglist = [];
          //   // res.data.data[i].aimglist.push(this.domainUrl + ele.aimg);
          //   // res.data.data[i].ximglist = [];
          //   // res.data.data[i].ximglist.push(this.domainUrl + ele.ximg);
          // });
          this.userList = res.data.data;
          this.totals = res.data.total;
          console.log(this.userList)
        }
      });
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
      this.auditLis();
    },
    //搜索
    onSubmit() {
      // console.log(this.userform);
      this.currentindex = 1;
      this.auditLis();
    },
    //取消搜索
    quxiao() {
      this.userform.order_id = "";
      this.userform.serial_number = "";
      this.userform.status = "";
      this.userform.username = "";
      this.userform.email = "";
      this.userform.p_id = "";
      this.userform.model = "";
      this.userform.platform = "";
      this.currentindex = 1;
      this.auditLis();
    },
    //通过 handleClick
    handleClick(e) {
      // console.log(e);
      this.$confirm("是否通过该积分申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let data = {
          id: e.id,
          status: 1
        };
        auditsh(data).then(res => {
          // console.log(res);
          if (res.status_code == 200) {
            // this.currentindex = 1;
            this.auditLis();
          }
        });
      });
    },
    //拒绝弹窗
    editbox(e) {
      this.titleName = "申请拒绝";
      this.pop_up = true;
      // console.log(e);
      this.juid = e.id;
    },
    //拒绝弹窗提交
    SubmitAdd() {
      if (this.Edform.reason !== "" && this.Edform.reason !== undefined) {
        let data = {
          id: this.juid,
          status: 2,
          reason: this.Edform.reason
        };
        auditsh(data).then(res => {
          // console.log(res);
          if (res.status_code == 200) {
            this.pop_up = false;
            // this.currentindex = 1;
            this.auditLis();
            this.juid = "";
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "请输入拒绝原因!"
        });
      }
    },
    //拒绝弹窗关闭
    cancelform() {
      this.pop_up = false;
      this.deilt = false;
      this.Edform.reason = "";
    },
    //批量拒绝弹窗关闭
    cancelformTwo() {
      this.pop_upTwo = false;
      this.EdformTWO.reason = "";
    },
    //批量拒绝弹窗提交
    SubmitAddTwo() {
      if (this.EdformTWO.reason !== "" && this.EdformTWO.reason !== undefined) {
        let data = {
          ids: this.Checklist.toString(),
          type: "refuse",
          reason: this.EdformTWO.reason
        };
        batchoperation(data).then(res => {
          // console.log(res);
          if (res.status_code == 200) {
            this.pop_upTwo = false;
            this.Checklist = [];
            // this.currentindex = 1;
            this.auditLis();
            this.$message({
              type: "success",
              message: "成功拒绝"
            });
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: "请输入拒绝原因!"
        });
      }
    },
    //选中
    handleSelectionChange(val) {
      // console.log(val);
      this.Checklist = [];
      val.forEach(ele => {
        this.Checklist.push(ele.id);
      });

      // console.log(this.Checklist.join(","));
    },
    //导出
    exportlist() {
      let data = {
        ids: this.Checklist.toString(),
        type: "audit_integral",
        where: {}
      };
      if (
        this.userform.order_id == "" &&
        this.userform.model == "" &&
        this.userform.serial_number == "" &&
        this.userform.status == ""
      ) {
        data.where = "";
      } else if (this.userform.order_id !== "") {
        data.where.order_id = this.userform.order_id;
      } else if (this.userform.model !== "") {
        data.where.model = this.userform.model;
      } else if (this.userform.serial_number !== "") {
        data.where.serial_number = this.userform.serial_number;
      } else if (this.userform.status !== "") {
        data.where.status = this.userform.status;
      }
      excelexport(data).then(res => {
        // console.log(res);
        const blob = new Blob([res]);
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = "积分审核.xlsx"; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
      });
    },
    //批量通过----批量拒绝
    batch(e) {
      // console.log(e);
      // console.log(this.Checklist);
      // console.log(this.Checklist.toString());
      if (this.Checklist.length > 0) {
        if (e == 1) {
          //通过
          let data = {
            ids: this.Checklist.toString(),
            type: "pass",
            reason: ""
          };
          batchoperation(data).then(res => {
            // console.log(res);
            if (res.status_code == 200) {
              this.$message({
                type: "success",
                message: "成功通过"
              });
              this.Checklist = [];
              // this.currentindex = 1;
              this.auditLis();
            }
          });
        } else {
          //拒绝
          this.titleName = "申请拒绝";
          this.pop_upTwo = true;
        }
      } else {
        this.$message({
          type: "warning",
          message: "请勾选相关订单"
        });
      }
    },
    //详情
    detailsbox(e) {
      console.log(e);
      e.aimglist = []
      e.ximglist = []
      e.aimg.split(",").forEach(eles => {
        e.aimglist.push(this.domainUrl + eles);
      });
      e.ximg.split(",").forEach(eled => {
        e.ximglist.push(this.domainUrl + eled);
      });
      this.detailsData = e;
      this.deilt = true;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.domainName();
    // this.auditLis();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.toExamine {
  padding: 20px 30px 0;
  .form_header {
    display: flex;
    justify-content: space-between;
    .btn_box {
      margin-left: 20px;
    }
    .el-button {
      margin-bottom: 20px;
    }
  }
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    padding: 0 0 20px 0;
  }
  .deilt {
    .boxTwo {
      width: 100%;
      display: flex;
      margin-bottom: 10px;
      .name {
        width: 100px;
      }
      .title {
        margin-left: 10px;
        display: flex;
        span {
          margin-right: 8px;
        }
        img {
          width: 100px;
          margin-right: 10px;
          border: 1px solid #000;
        }
      }
    }
  }
}
</style>
<style lang='scss'>
.toExamine {
  .form_header {
    .el-form-item {
      // margin-bottom: 20px;
    }
  }

  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
}
</style>